/* Desktop mega-menu: open on hover, close the instant the pointer leaves.
 *
 * 2026-10-28 (owner: "make it as fast as possible for that pop-up to
 * disappear"). The old version closed 250 ms after mouseleave, a blanket
 * grace period that existed only because the panel hangs off the bottom of
 * <header> (top:100%), so moving straight down from the link into the panel
 * crosses a strip of header that is NOT inside <header-menu>. Now, instead of
 * waiting, we look at where the pointer actually is: inside the link, inside
 * the panel, or in the corridor straight down between them = keep open;
 * anywhere else = close at once. A click anywhere outside, Escape, or hovering
 * a different top-level item also closes it immediately. A 300 ms fallback
 * still closes it if the pointer leaves the window or stops in the corridor.
 */
document.addEventListener('DOMContentLoaded', function () {
  var DESKTOP = 1025;
  var menus = [];

  function isDesktop() { return window.innerWidth >= DESKTOP; }

  function closeAll(except) {
    menus.forEach(function (m) { if (m !== except) m.close(); });
  }

  document.querySelectorAll('.main-menu > li.mega-menu header-menu').forEach(function (el) {
    var details = el.querySelector('details');
    if (!details) return;
    var summary = details.querySelector('summary');
    var panel = details.querySelector('.sub-menu');
    var fallback = null;
    var tracking = false;

    function stopTracking() {
      if (tracking) {
        document.removeEventListener('pointermove', onMove);
        tracking = false;
      }
      clearTimeout(fallback);
      fallback = null;
    }

    function open() {
      if (!isDesktop()) return;
      stopTracking();
      closeAll(menu);
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    function close() {
      stopTracking();
      if (!details.hasAttribute('open')) return;
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }

    function inside(r, x, y) {
      return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
    }

    /* True while the pointer is somewhere the menu should stay open. */
    function pointerAllowed(x, y) {
      var s = (summary || el).getBoundingClientRect();
      if (inside(s, x, y)) return true;
      if (panel) {
        var p = panel.getBoundingClientRect();
        if (inside(p, x, y)) return true;
        /* corridor: straight down from the link to the top of the panel */
        if (x >= s.left && x <= s.right && y >= s.bottom && y <= p.top) return true;
      }
      return false;
    }

    function onMove(e) {
      if (!pointerAllowed(e.clientX, e.clientY)) close();
    }

    var menu = { el: el, close: close };
    menus.push(menu);

    el.addEventListener('mouseenter', open);
    el.addEventListener('mouseleave', function () {
      if (!isDesktop() || !details.hasAttribute('open')) return;
      tracking = true;
      document.addEventListener('pointermove', onMove);
      fallback = setTimeout(close, 300);
    });

    if (summary) {
      // On desktop, hover already controls open/close - a click on the
      // trigger would otherwise toggle the native <details> closed again.
      summary.addEventListener('click', function (event) {
        if (!isDesktop()) return;
        event.preventDefault();
      });
    }
  });

  if (!menus.length) return;

  /* Click (or tap) anywhere outside the open menu: close now. */
  document.addEventListener('pointerdown', function (e) {
    if (!isDesktop()) return;
    menus.forEach(function (m) {
      if (!m.el.contains(e.target)) m.close();
    });
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* Pointer left the window entirely. */
  document.addEventListener('mouseleave', function () { if (isDesktop()) closeAll(); });
});
